import React from "react";

export const formGroupKSU = {
  kodeKSU: {value: "", mandatory: true},
  name: {value: "", mandatory: true},
  category: {value: {}, mandatory: true},
  satuan: {value: {}, mandatory: true},
  status: {value: "ACTIVE"},
};

export const formGroupHadiah = {
  kodeHadiah: {value: "", mandatory: true},
  nameHadiah: {value: "", mandatory: true},
  categoryHadiah: {value: {}, mandatory: true},
  qrHadiah: {value: {}, mandatory: true},
  satuanHadiah: {value: {}, mandatory: true},
  status: {value: "ACTIVE"},
};

export const formGroupOtherItem = {
  kodeotheritem: {value: "", mandatory: true},
  nameotheritem: {value: "", mandatory: true},
  categoryotheritem: {value: {}, mandatory: true},
  qrotheritem: {value: {}, mandatory: true},
  satuanotheritem: {value: {}, mandatory: true},
  status: {value: "ACTIVE"},
};

export const tableConfig = {
  ksu: [
    {
      name: "kodeKSU",
      label: "Kode KSU",
      options: {
        sort: false,
      },
    },
    {
      name: "name",
      label: "Nama KSU",
      options: {
        sort: false,
      },
    },
    {
      name: "categoryDTO",
      label: "Kategori",
      options: {
        customBodyRender: (val) => <p>{val?.value}</p>,
        sort: false,
      },
    },
    {
      name: "satuanDTO",
      label: "Satuan",
      options: {
        customBodyRender: (val) => <p>{val?.value}</p>,
        sort: false,
      },
    }
  ],
  hadiah: [
    {
      name: "kodeHadiah",
      label: "Kode Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "nameHadiah",
      label: "Nama Hadiah",
      options: {
        sort: false,
      },
    },
    {
      name: "categoryHadiah",
      label: "Kategori",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "qrHadiah",
      label: "QR Code",
      options: {
        customBodyRender: (val) => <p>{val ? "YES" : "NO"}</p>,
        sort: false,
      },
    },
    {
      name: "satuanHadiah",
      label: "Satuan",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    }
  ],
  baranglain: [
    {
      name: "kodeotheritem",
      label: "Kode Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "nameotheritem",
      label: "Nama Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "categoryotheritem",
      label: "Kategori",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "qrotheritem",
      label: "QR Code",
      options: {
        customBodyRender: (val) => <p>{val ? "YES" : "NO"}</p>,
        sort: false,
      },
    },
    {
      name: "satuanotheritem",
      label: "Satuan",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    }
  ],
};
